<template>
  <div id="Homebox" v-loading="loading">
    <div class="header">
      <el-header class="Homeboxtop">
        <div class="header-left">
          <div
            class="Homeboxtopleft"
            :style="{
              'border-right': otherAppObj[link_type]
                ? 'none'
                : ' 2px solid #dcdcdc',
            }"
          >
            <div @click="ticket">
              <img v-if="isHomework" src="@/assets/img/homework_logo.png" />
              <img v-else-if="isClassTable" src="@/assets/img/classTable.png" />
              <img
                v-else-if="link_type == 'otherCourseSelection'"
                src="@/assets/img/courseSelection.svg"
              />
              <img
                v-else-if="link_type == 'courseManagement'"
                src="@/assets/img/courseManagement.png"
              />
              <img
                v-else-if="link_type == 'orgManagement'"
                src="@/assets/img/orgManagement.png"
              />
              <img
                v-else-if="link_type == 'riskWarn'"
                src="@/assets/img/warning.png"
              />
              <img v-else src="@/assets/img/logo.png" />
            </div>
            <div class="header-title">
              <span>
                {{
                  (platformCode == "341600" || platformCode == "441300")
                    ? " “双减”综合服务 "
                    : otherAppObj[link_type] || "课后服务"
                }}
              </span>
            </div>
          </div>
          <div
            v-show="!otherAppObj[link_type]"
            :class="{ Homeboxtopcenter: true, mr: orgList.length == 1 }"
            :title="Userlist.last_top_org_name"
          >
            <div v-if="orgList.length == 1 || Userlist.platformVersion == 6">
              {{ Userlist.last_top_org_name || "未知机构" }}
            </div>

            <!-- 切换学校控件 placement="bottom-end"-->
            <div
              class="select-org-box"
              v-if="Userlist.platformVersion == 7 && orgList.length > 1"
            >
              <el-dropdown>
                <div class="cur-select-org">
                  <span :title="Userlist.last_top_org_name">{{
                    Userlist.last_top_org_name
                  }}</span>
                </div>
                <el-dropdown-menu
                  slot="dropdown"
                  style="
                    width: auto;
                    min-width: 150px;
                    text-align: center;
                    padding: 5px 10px;
                  "
                >
                  <!-- 只显示组织类型, 1:教育局, 2:学校, 8:机构 -->
                  <el-dropdown-item
                    v-if="
                      o.org_type == '1' ||
                      o.org_type == '2' ||
                      o.org_type == '8'
                    "
                    v-for="(o, idx) in orgList"
                    :key="'org_' + idx"
                    :style="{
                      color:
                        Userlist.last_top_org_name == o.top_org_name
                          ? '#009dfd'
                          : '',
                    }"
                    @click.native="handleSwitchUseOrg(o)"
                  >
                    {{ o.top_org_name || "未知机构" }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div
            class="down"
            v-if="
              Userlist.platformVersion == 7 &&
              orgList.length > 1 &&
              !otherAppObj[link_type]
            "
          ></div>
          <el-tabs
            v-show="!otherAppObj[link_type]"
            v-model="tabName"
            @tab-click="handleClick"
            style="min-width: 600px; margin-right: 10px"
            class="demo-tabs"
          >
            <el-tab-pane
              :label="item.name"
              :name="item.name"
              :path="item.lable"
              v-for="(item, index) in tabList"
              :key="index + item.lable"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="Homeboxtopright">
          <div style="margin-top: -10px; margin-right: 12px" class="UserAvatar">
            <img
              :src="
                Userlist.avatar
                  ? Userlist.avatar['1'] != ''
                    ? Userlist.avatar['1']
                    : 'https://css.wuhaneduyun.cn/tianyu_edu/common/images/nophoto_mid.gif?_r=1629685003'
                  : 'https://css.wuhaneduyun.cn/tianyu_edu/common/images/nophoto_mid.gif?_r=1629685003'
              "
              alt=""
            />
          </div>
          <div style="margin-top: -20px">
            你好，{{ Userlist.name ? Userlist.name : "XXX" }}
          </div>
          <div class="close_img"></div>
          <el-dropdown>
            <span class="el-dropdown-link">
              <i
                class="el-icon-setting el-icon--center"
                style="font-size: 22px; margin: 0px"
              ></i>
            </span>
            <el-dropdown-menu
              slot="dropdown"
              style="width: 80px; text-align: center; margin-top: -3px"
            >
              <el-dropdown-item @click.native="goUsercenter"
                >个人中心</el-dropdown-item
              >
              <el-dropdown-item
                v-if="controlManageter != ''"
                @click.native="goManageter"
              >
                {{ controlManageter }}
              </el-dropdown-item>
              <el-dropdown-item @click.native="loginOut">退出</el-dropdown-item>
              <!-- <el-dropdown-item @click.native="ticket">获取ticket</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
    </div>
    <!-- 机构管理-切换 -->
    <div
      class="flex_tab"
      v-if="tabType === 'eduMechanism' && tabName === '机构管理'"
    >
      <span
        v-for="(item, index) in tabListJG"
        :class="['res-tab', { active: item === tabName_jg }]"
        :key="index + 'jg'"
        @click="tabClickJG(item)"
      >
        {{ item }}
      </span>
    </div>
    <el-container
      class="Homeboxcontent"
      v-if="isHomeShow"
      :class="{
        jg_height: tabType === 'eduMechanism' && tabName === '机构管理',
      }"
    >
      <template>
        <el-aside
          v-show="
            tabType !== 'HomeOverview' &&
            tabType !== 'schedule' &&
            tabType !== 'timetable' &&
            tabType !== 'homeViews' &&
            tabType !== 'homePageEducation' &&
            tabType !== 'notice' &&
            tabName_jg !== '校外培训机构' &&
            tabType !== 'educationTask' &&
            tabType !== 'tableClass' &&
            tabType !== 'educationCourseManager'
          "
        >
          <pan-menu
            @getMenuObj="getMenuObj"
            :tabType="tabType"
            :roles="roles"
          ></pan-menu>
        </el-aside>
        <el-main>
          <iframe
            v-if="clickMenuObj.url"
            :src="clickMenuObj.url"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
          <template v-else>
            <!-- <keep-alive> -->
            <router-view></router-view>
            <!-- </keep-alive> -->
          </template>
        </el-main>
      </template>
    </el-container>
    <div id="NoPermission" v-else>
      <div class="Permissionbox">
        <img src="../assets/img/not_qx.png" alt="" />
        <a href="https://www.wuhaneduyun.cn/login/login.html"
          >获取信息失败，点击请重新登录</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import {
  querySessionUser,
  chkHeartbeat,
  validUserPriv,
} from "../api/PublicApi";
import PanMenu from "./components/menu.vue";
import api from "@/api/wisdomSchool/index.js";
import _ from "lodash";
import { getSixUser, getSevenUser } from "@/api/user/user.js";
import {
  getTicket,
  getManager,
  changeUserTopOrg,
} from "@/api/user/userCenter.js";
import heartbeat from "@/utils-khfw/heartbeat.js";
export default {
  components: {
    PanMenu,
  },
  data() {
    return {
      tabName: "首页概览",
      tabType: "",
      roles: "",
      isHomeShow: true,
      loading: false,
      tabList: [],
      platformCode: sessionStorage.getItem("platformCode"),
      Userlist: JSON.parse(sessionStorage.getItem("userInfo")) || {},
      roleName: "",
      userName: "",
      clickMenuObj: {},
      tabListJG: ["课后服务机构", "校外培训机构"],
      tabName_jg: "课后服务机构",
      isHomework: sessionStorage.getItem("linktype") === "homework",
      isClassTable: sessionStorage.getItem("linktype") === "classTable",
      domain: sessionStorage.getItem("domain") || "https://www.wuhaneduyun.cn",
      usessionid: sessionStorage.getItem("usessionid") || "",
      link_type: sessionStorage.getItem("linktype"),
      otherAppObj: {
        homework: "作业管理",
        classTable: "延时课表",
        otherCourseSelection: "校本选课",
        courseManagement: "课程管理",
        orgManagement: "机构管理",
        riskWarn: "风险预警",
      },
    };
  },
  watch: {
    $route: {
      handler(to, from) {},
      deep: true,
      immediate: true,
    },
    // 教育局-机构管理切换 课后服务机构/校外培训机构
    tabName_jg(n, o) {
      if (n === "课后服务机构") {
        this.$router.push("/education/mechanism/orginManagement");
      } else {
        this.$router.push("/education/mechanism/outSchoolUnit");
      }
    },
  },
  computed: {
    controlManageter() {
      let org_type = sessionStorage.getItem("org_type");
      let user_type = sessionStorage.getItem("user_type");
      if (user_type == "1" && sessionStorage.getItem("isManager") == 1) {
        return "学校管理";
      } else if (
        org_type == "5" ||
        org_type == "8" ||
        org_type == "1" ||
        org_type == "4"
      ) {
        return "机构管理";
      } else {
        return "";
      }
    },
    orgList() {
      if (this.Userlist.platformVersion == 6) {
        return [];
      }
      let emptyList = [];
      this.Userlist.user_top_org.forEach((it) => {
        // 屏蔽学生和家长角色
        if (it.user_type != "0" && it.user_type != "2") {
          emptyList.push(it);
        }
      });
      return emptyList;
    },
  },
  mounted() {
    window.addEventListener("popstate", (e) => this.popstateHandler(e));
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    if (sessionStorage.tabName && sessionStorage.tabType) {
      sessionStorage.removeItem("tabName");
      sessionStorage.removeItem("tabType");
    }
    // 自动心跳
    heartbeat.start();
  },
  created() {
    // 亳州 的单独名称
    document.title =
      (this.platformCode == "341600" ||this.platformCode == "441300")
        ? " “双减”综合服务 "
        : this.otherAppObj[this.link_type] || "课后服务";

    this.isHomeShow = this.$route.query.isHomeShow == "false" ? false : true;
    if (window != top) {
      top.location.href = location.href;
    }
    this.initUser();
  },
  methods: {
    async initUser() {
      let org_type = sessionStorage.getItem("org_type");
      let user_type = sessionStorage.getItem("user_type");
      // 判断组织类型 1:教育局, 2:学校, 8:机构 (1机构，2学校，8企业，9教学工作室，10平台)
      // 判断用户类型 user_type	0:学生，1:老师，2:家长，3:工作人员，4:机构人员，5:企业人员，12:市民
      if (org_type == "5" || org_type == "8") {
        this.roles = "mechanism";
      } else if (org_type == "2") {
        this.roles = "school";
      } else if (org_type == "1" || org_type == "4") {
        this.roles = "education";
      } else if ((user_type == "0" || user_type == "1", user_type == "2")) {
        //没有机构类型就用用户类型来判断
        this.roles = "school";
      } else {
        alert("无法识别用户类型无非进入课后服务系统");
      }
      // this.roles = "school";
      // console.log("当前环境--", process.env);
      let obj = {
        type: this.roles,
      };
      window.sessionStorage.setItem("type", JSON.stringify(obj));
      if (this.roles == "mechanism") {
        if (this.isClassTable) {
          this.tabName = "延时课表";
          this.tabType = "timetable";
          this.tabList = [{ name: "延时课表", lable: "timetable" }];
        } else if (this.link_type == "courseManagement") {
          this.tabName = "课程管理";
          this.tabType = "supervise";
          this.tabList = [{ name: "课程管理", lable: "supervise" }];
        } else if (this.link_type == "orgManagement") {
          this.tabName = "机构管理";
          this.tabType = "personnel";
          this.tabList = [{ name: "机构管理", lable: "personnel" }];
        } else {
          this.tabList = [
            { name: "首页概览", lable: "homeViews" },
            { name: "机构管理", lable: "personnel" },
            { name: "课程管理", lable: "supervise" },
            { name: "延时课表", lable: "timetable" },
            { name: "统计分析", lable: "analysis" },
            { name: "运营管理", lable: "operate" },
            { name: "通知公告", lable: "notice" },
          ];
          this.tabType = "homeViews";
          this.tabName = "首页概览";
        }
      } else if (this.roles == "school") {
        if (this.isHomework) {
          this.tabName = "作业管理";
          this.tabType = "Task";
          this.tabList = [{ name: "作业管理", lable: "Task" }];
        } else if (this.isClassTable) {
          this.tabName = "延时课表";
          this.tabType = "schedule";
          this.tabList = [{ name: "延时课表", lable: "schedule" }];
        } else if (this.link_type == "otherCourseSelection") {
          this.tabName = "校本选课";
          this.tabType = "OtherAppCourseSelection";
          this.tabList = [
            { name: "校本选课", lable: "OtherAppCourseSelection" },
          ];
        } else if (this.link_type == "courseManagement") {
          this.tabName = "课程管理";
          this.tabType = "courseManager";
          this.tabList = [{ name: "课程管理", lable: "courseManager" }];
        } else {
          if (user_type == "1") {
            //教师角色
            this.tabType = "HomeOverview";
            this.tabName = "首页概览";
            //普通教师不能查看课程管理，服务管理
            if (sessionStorage.getItem("isManager") == 1) {
              this.tabList = [
                { name: "首页概览", lable: "HomeOverview" },
                { name: "课程管理", lable: "courseManager" },
                { name: "校本选课", lable: "courseSelection" },
                { name: "延时课表", lable: "schedule" },
                // { name: "统计分析", lable: "statistical" },
                { name: "服务管理", lable: "service" },
                { name: "通知公告", lable: "notice" },
              ];
            } else {
              this.tabList = [
                { name: "首页概览", lable: "HomeOverview" },
                { name: "校本选课", lable: "courseSelection" },
                { name: "延时课表", lable: "schedule" },
                // { name: "统计分析", lable: "statistical" },
                { name: "通知公告", lable: "notice" },
              ];
            }
          } else {
            this.tabType = "HomeOverview";
            this.tabName = "首页概览";
            this.tabList = [
              { name: "首页概览", lable: "HomeOverview" },
              // { name: "学校管理", lable: "SchoolManager" },
              { name: "课程管理", lable: "courseManager" },
              { name: "校本选课", lable: "courseSelection" },
              { name: "延时课表", lable: "schedule" },
              // { name: "统计分析", lable: "statistical" },
              { name: "服务管理", lable: "service" },
              { name: "通知公告", lable: "notice" },
              // { name: "机构统计", lable: "Sort" },
              // { name: "数据看板", lable: "Data" },
            ];
          }
        }
      } else if (this.roles == "education") {
        if (this.isHomework) {
          this.tabName = "作业管理";
          this.tabType = "educationTask";
          this.tabList = [{ name: "作业管理", lable: "educationTask" }];
        } else if (this.isClassTable) {
          this.tabName = "延时课表";
          this.tabType = "tableClass";
          this.tabList = [{ name: "延时课表", lable: "tableClass" }];
        } else if (this.link_type == "courseManagement") {
          this.tabName = "课程管理";
          this.tabType = "educationCourseManager";
          this.tabList = [
            { name: "课程管理", lable: "educationCourseManager" },
          ];
        } else if (this.link_type == "orgManagement") {
          this.tabName = "机构管理";
          this.tabType = "eduMechanism";
          this.tabList = [{ name: "机构管理", lable: "eduMechanism" }];
        } else if (this.link_type == "riskWarn") {
          this.tabName = "风险预警";
          this.tabType = "riskWarning";
          this.tabList = [{ name: "风险预警", lable: "riskWarning" }];
        } else {
          this.tabType = "homePageEducation";
          this.tabName = "首页概览";
          this.tabList = [
            { name: "首页概览", lable: "homePageEducation" },
            { name: "机构管理", lable: "eduMechanism" },
            { name: "课程管理", lable: "educationCourseManager" },
            { name: "延时课表", lable: "tableClass" },
            // { name: "资金管理", lable: "moneyManager" },
            { name: "运营管理", lable: "operation" },
            { name: "风险预警", lable: "riskWarning" },
            // { name: "统计分析", lable: "educationStatistical" },
          ];
        }
      }
    },
    //新增切换学校
    async handleSwitchUseOrg(newOrg) {
      try {
        console.log("org--", { ...newOrg });
        // 如果点击的是当前学校，则不做任何操作
        if (this.Userlist.last_top_org_name == newOrg.top_org_name) return;
        // 切换用户组织
        const changeRes = await changeUserTopOrg({
          usession_id: this.Userlist.usession_id,
          top_org_id: newOrg.top_org_id,
          user_type: newOrg.user_type,
        });
        console.log("--->切换组织：", changeRes, location.href);
        let ticket = await getTicket(this.Userlist.usession_id);
        // 切换后重新进入课后服务系统
        //  window.open(
        //   `http://assfe.tianyuyun.com/?ticket=${ticket}`,
        //   "_self"
        // );
        this.$router.replace({
          name: "Entry",
          query: { ticket: ticket, platformCode: sessionStorage.platformCode },
        });
      } catch (err) {
        this.$message.error("切换机构失败");
      }
    },
    loginOut() {
      if (this.domain.indexOf("http") == -1) {
        window.open(
          `https://${this.domain}/index.php?r=portal/user/logout&service=https://${this.domain}/index.php?r=portal/supervise/login&site=yn`,
          "_self"
        );
      } else {
        window.open(
          `${this.domain}/index.php?r=portal/user/logout&service=${this.domain}/index.php?r=portal/supervise/login&site=yn`,
          "_self"
        );
      }

      window.sessionStorage.clear();
      // window.close();
    },
    async ticket() {
      let ticket = await getTicket(this.usessionid);
    },
    async goUsercenter() {
      let ticket = await getTicket(this.usessionid);
      if (sessionStorage.platformCode == "410182") {
        window.open(
          `https://www.xyeduyun.cn/userinfo/?platformCode=410182&ticket=${ticket}`
        );
      } else {
        window.open(
          `https://u-info.tianyuyun.com?ticket=${ticket}&platformCode=${sessionStorage.getItem(
            "platformCode"
          )}`
        );
      }
    },
    async goManageter() {
      let ticket = await getTicket(this.usessionid);
      window.open(
        `${sessionStorage.uc7manageUrl}/account/login-by-ticket?service=&ticket=${ticket}`
      );
    },
    getMenuObj(obj) {
      this.clickMenuObj = obj;
    },
    tabClick(item) {
      if (item.lable == "monitor" || item.lable == "Data") {
        // 根据lable 来判断是否跳转到数据大屏
        window.open(
          "http://datax.huijiaoyun.com/screen/view/7xqPZOM3n8r-Ddd_MXRsAl_XV8lHxq_M"
        );
      } else if (item.lable == "SchoolManager") {
        // 学校管理
      } else {
        this.tabName = item.name;
        this.tabType = item.lable;
      }
    },
    RouterClick(item) {
      this.name = item.name;
    },
    async handleClick(tab, event) {
      // console.log("tabs切换", tab,this.tabName );
      let platformCode = sessionStorage.getItem("platformCode");
      if (tab.$attrs.path == "monitor" || tab.$attrs.path == "Data") {
        // 根据lable 来判断是否跳转到数据大屏
        window.open(
          "http://datax.huijiaoyun.com/screen/view/7xqPZOM3n8r-Ddd_MXRsAl_XV8lHxq_M"
        );
      } else if (tab.$attrs.path == "notice") {
        // 通知公告
        let ticket = await getTicket(this.usessionid);
        window.open(
          `http://notice.huijiaoyun.com/index.php?ticket=${ticket}&platformcode=${platformCode}`
        );
        this.tabList.forEach((it) => {
          if (this.$route.path.indexOf(it.lable) != -1) {
            this.tabName = it.name;
            this.tabType = it.lable;
          }
        });
      } else if (tab.$attrs.path == "courseSelection") {
        let ticket = await getTicket(this.usessionid);
        // 校本选课
        const ISPROD = process.env.VUE_APP_MODE === "test";
        if (ISPROD) {
          if (sessionStorage.getItem("isManager") == 1) {
            window.open(
              `http://zhxy-app-elective.d.huijiaoyun.com/setting/activity?platformcode=${platformCode}&ticket=${ticket}`
            );
          } else {
            window.open(
              `http://zhxy-app-elective.d.huijiaoyun.com?platformcode=${platformCode}&ticket=${ticket}`
            );
          }
        } else {
          if (sessionStorage.getItem("isManager") == 1) {
            window.open(
              `${sessionStorage.zhxyElectiveUrl}/setting/activity?platformcode=${platformCode}&ticket=${ticket}`
            );
            console.log(
              "校本选择跳转地址:",
              `${sessionStorage.zhxyElectiveUrl}/setting/activity?platformcode=${platformCode}&ticket=${ticket}`
            );
          } else {
            window.open(
              `${sessionStorage.zhxyElectiveUrl}?platformcode=${platformCode}&ticket=${ticket}`
            );
            console.log(
              "校本选择跳转地址:",
              `${sessionStorage.zhxyElectiveUrl}?platformcode=${platformCode}&ticket=${ticket}`
            );
          }
        }
        // 让菜单回到之前位置
        this.tabList.forEach((it) => {
          if (this.$route.path.indexOf(it.lable) != -1) {
            this.tabName = it.name;
            this.tabType = it.lable;
          }
        });
      } else {
        this.clickMenuObj = {};
        this.tabName = tab.label;
        this.tabType = tab.$attrs.path;
      }
    },
    tabClickJG(item) {
      this.tabName_jg = item;
    },
    // 浏览器回退时定位菜单栏位置
    popstateHandler(e) {
      e = e || window.event;
      if (e) {
        this.tabList.forEach((it) => {
          if (this.$route.path.indexOf(it.lable) != -1) {
            this.tabName = it.name;
            this.tabType = it.lable;
            if (sessionStorage.menuPath) {
              this.$router.push(sessionStorage.menuPath);
            }
          }
        });
      }
    },
    beforeunloadHandler(e) {
      e = e || window.event;
      if (e) {
        sessionStorage.tabName = this.tabName;
        sessionStorage.tabType = this.tabType;
        // e.returnValue = '关闭提示'
      }
      // return '关闭提示'
    },
  },
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
#Homebox {
  width: 100vw;
  height: 100vh;
  background-color: #f4f4f4;
  .header {
    background: #ffffff;
    width: 100%;
    height: 88px;
    display: flex;
    justify-content: center;
    .header-left {
      display: flex;
    }

    ::v-deep .el-icon-arrow-left {
      margin-top: 42px;
    }
    ::v-deep .el-icon-arrow-right {
      margin-top: 42px;
    }
  }
  .Homeboxtop {
    // width: 1200px;
    height: 88px !important;
    line-height: 88px;
    display: flex;
    justify-content: space-between;
    .Homeboxtopleft {
      padding-right: 15px;
      display: flex;
      justify-content: flex-start;
      vertical-align: middle;
      height: 30px;
      line-height: 30px;
      margin-top: 30px;
      .header-title {
        height: 100%;
        margin-left: 12px;
        line-height: 30px;
        font-size: 20px;
        color: #000;
        font-weight: bold;
      }
      img {
        width: 30px;
        height: 30px;
      }
    }

    .Homeboxtopcenter {
      display: flex;
      justify-content: space-between;
      padding: 2px 0px 0px 14px;
      &.mr {
        margin-right: 30px;
      }
      div {
        font-weight: 400;
        font-size: 20px;
        max-width: 160px;
        // 省略号
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      ul > li {
        float: left;
        margin-left: 29px;
        font-size: 16px;
        color: #555555;
        cursor: pointer;
      }
      .select-org-box {
        padding-top: 15px;
        .cur-select-org {
          width: 100%;
          text-align: left;
          cursor: pointer;
          span {
            max-width: 140px;
            display: inline-block;
            font-weight: 400;
            font-size: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .down {
      margin: 45px 30px 0 0;
      display: inline-block;
      margin-left: 8px;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 7px solid #9b9b9b;
    }
    .Homeboxtopright {
      height: 44px;
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      padding-left: 15px;
      .UserAvatar {
        width: 30px;
        height: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .close_img {
        display: inline-block;
        // width: 60px;
        height: 30px;
        padding-left: 20px;
        margin-top: 9px;
        margin-left: 20px;
        border-left: 2px solid #dcdcdc;
        // cursor: pointer;
        // img {
        //   width: 22px;
        //   height: 22px;
        //   margin-bottom: 23px;
        // }
      }
      div:nth-child(1) {
        margin-top: -50px;
      }
      img {
        border-radius: 50%;
      }
    }
  }
  .Homeboxcontent {
    width: 1200px;
    margin: 20px auto;
    height: calc(100vh - 110px);
    .FullScreen {
      width: 100%;
      height: 100%;
      text-align: center;
      background-color: #000000;
    }
  }

  .Permissionbox {
    transform: translate(-50%, -50%);
    text-align: center;
    color: #b2b2b2;
    font-size: 20px;
    a {
      display: block;
      cursor: pointer;
    }
  }
  .el-header {
    min-width: 1200px;
    padding: 0px;
    background-color: #ffffff;
  }
  .el-aside {
    background-color: #f5f7f9;
    width: 200px !important;
    ul > li {
      cursor: pointer;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      a {
        display: block;
        width: 100%;
        text-align: center;
        height: 100%;
        color: #000000;
        font-family: PingFang SC;
        font-weight: 400;
      }
    }
  }
  .el-main {
    background-color: #ffffff;
    padding: 0px;
    height: 100%;
    overflow-y: auto;
  }
}

::v-deep .el-tabs__nav {
  height: 72px;
  margin-top: 3px;
}
::v-deep .el-tabs__nav-wrap::after {
  opacity: 0;
}

::v-deep .el-tabs__nav-wrap::after {
  opacity: 0;
}
.flex_tab {
  width: 1200px;
  margin: 20px auto;
  display: flex;
  span {
    font-size: 15px;
    margin-right: 20px;
    cursor: pointer;
    padding-bottom: 15px;
  }
  .active {
    color: #4991e1;
    border-bottom: 3px solid #4991e1;
  }
}
.jg_height {
  height: calc(100% - 150px) !important;
}
.el-dropdown {
  cursor: pointer;
  height: 50px;
  line-height: 55px;
}
.el-dropdown-link el-dropdown-selfdefine {
  height: 2px;
}
</style>
